import { action, computed, observable } from 'mobx';
import { OfferGroupResponse } from '~client/model/offer-group-response';
import { createResaleListing } from '~web/interactor/resale/create-resale-listing';
import { TaskStore } from '~web/store/base/task-store';
import { TokenInfo } from '~web/view/model/token-info';

export class SellingStore extends TaskStore<OfferGroupResponse> {
  token: TokenInfo;
  sellableTokens: TokenInfo[];
  @observable offerGroupId: number;
  @observable price: number;
  @observable revokeWarningShown: boolean;
  @observable initialPrice: number;

  constructor() {
    super(createResaleListing);
    this.clear();
  }

  initialize(token: TokenInfo, sellableTokens: TokenInfo[]): void {
    this.clear();
    this.token = token;
    this.sellableTokens = sellableTokens;
    this.offerGroupId = token.sellingOfferGroupId;
    this.initialPrice = token.sellingPrice;
    this.price = this.initialPrice;
  }

  @computed
  get isPriceEdited(): boolean {
    return this.price !== this.initialPrice;
  }

  @action
  setPrice = (price: number): void => {
    this.price = price;
  };

  @action
  showRevokeWarning(): void {
    this.revokeWarningShown = true;
  }

  @action
  hideRevokeWarning(): void {
    this.revokeWarningShown = false;
  }

  @action
  submit(tokenIds: number[], payoutMethodId: number): void {
    this.execute({
      inventoryItemIds: tokenIds,
      oldOfferGroupId: this.offerGroupId,
      payoutMethodId: payoutMethodId,
      reservePrice: this.price,
    });
  }

  /**
   * @override
   */
  clear(): void {
    super.clear();
    this.token = undefined;
    this.sellableTokens = undefined;
    this.offerGroupId = undefined;
    this.price = undefined;
    this.revokeWarningShown = false;
    this.initialPrice = undefined;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/store/selling/selling-store.ts